import { alpha, ButtonBase, InputBase, Stack, styled } from '@mui/material';
import { fieldBackground } from 'src/components/ExpandableTextArea/field-background';

export const SelectorRow = styled(Stack, { name: 'TriageConfigSelectorRow' })(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(0.75),
}));

export const SelectorTriggerBox = styled(ButtonBase, { name: 'TriageConfigSelectorTrigger' })(
  ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: '1 1 auto',
    minWidth: 0,
    height: '2.375rem',
    padding: '0 0.6875rem',
    borderRadius: '0.5625rem',
    border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
    backgroundColor: fieldBackground(theme),
    color: theme.palette.custom.OV.sys.onBackground,
    fontFamily: theme.typography.fontFamily,
    cursor: 'pointer',
    '&:hover': { borderColor: theme.palette.custom.OV.sys.outline },
    '&:focus-visible': { borderColor: theme.palette.custom.OV.sys.primary },
    '&.Mui-disabled': { opacity: 0.5, cursor: 'default' },
  }),
);

export const SelectorTriggerIcon = styled('span', { name: 'TriageConfigSelectorTriggerIcon' })(
  ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    '& svg': { width: '1.0625rem', height: '1.0625rem' },
  }),
);

export const SelectorTriggerName = styled('span', { name: 'TriageConfigSelectorTriggerName' })(
  {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '0.84375rem',
    fontWeight: 600,
    textAlign: 'left',
  },
);

export const SelectorDefaultBadge = styled('span', {
  name: 'TriageConfigSelectorDefaultBadge',
})(({ theme }) => ({
  flexShrink: 0,
  padding: '0.125rem 0.4375rem',
  borderRadius: '999px',
  backgroundColor: alpha(theme.palette.custom.OV.sys.secondary, 0.11),
  color: theme.palette.custom.OV.sys.secondary,
  fontSize: '0.625rem',
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  lineHeight: '1rem',
}));

export const SelectorTriggerChevron = styled('span', {
  name: 'TriageConfigSelectorTriggerChevron',
})(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  '& svg': { width: '0.9375rem', height: '0.9375rem' },
}));

export const SelectorRenameInput = styled(InputBase, {
  name: 'TriageConfigSelectorRenameInput',
})(({ theme }) => ({
  flex: '1 1 auto',
  minWidth: 0,
  height: '2.375rem',
  padding: '0 0.6875rem',
  borderRadius: '0.5625rem',
  border: `1px solid ${theme.palette.custom.OV.sys.primary}`,
  backgroundColor: fieldBackground(theme),
  fontFamily: theme.typography.fontFamily,
  fontSize: '0.84375rem',
  fontWeight: 600,
  '& input': { padding: 0 },
}));

export const SelectorOptionMeta = styled('span', {
  name: 'TriageConfigSelectorOptionMeta',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(0.875),
}));

export const SelectorOptionUsage = styled('span', {
  name: 'TriageConfigSelectorOptionUsage',
})(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  '& svg': { width: '0.6875rem', height: '0.6875rem', flexShrink: 0 },
}));

export const SelectorOptionMetaDot = styled('span', {
  name: 'TriageConfigSelectorOptionMetaDot',
})(({ theme }) => ({
  width: '0.1875rem',
  height: '0.1875rem',
  borderRadius: '50%',
  backgroundColor: theme.palette.custom.OV.sys.outline,
  flexShrink: 0,
}));
